import React from 'react';
import AdminLayout from './AdminLayout';
import CoachesTab from '../../components/admin/CoachesTab';

export default function AdminCoachesPage() {
    return (
        <AdminLayout title="Coaches" description="Manage coaching assignments and coach profiles">
            <CoachesTab />
        </AdminLayout>
    );
}
